import { render, staticRenderFns } from "./ucHead.vue?vue&type=template&id=33386550&scoped=true&"
import script from "./ucHead.vue?vue&type=script&lang=js&"
export * from "./ucHead.vue?vue&type=script&lang=js&"
import style0 from "./ucHead.vue?vue&type=style&index=0&id=33386550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33386550",
  null
  
)

export default component.exports